module.exports = __webpack_public_path__ + "static/media/zoom1.0688c0fa.svg";